import React from 'react';

import styled from 'styled-components';

import { Button, Stack, SvgIcon, Typography } from 'components';

import { useTranslation } from 'third-party';

const EmptyStateWrapper = styled(Stack)`
  gap: 2rem;
  max-width: 60rem;
  padding: 4rem;
  align-items: center;
  text-align: center;
  margin: auto;
  justify-content: center;
  height: 100%;
`;

const EmptyStateIconWrapper = styled(SvgIcon)`
  color: ${props => props.theme.custom.palette.secondary500};
  margin-bottom: 1rem;
`;

const EmptyStateTitle = styled(Typography)`
  font-size: 2.4rem;
  font-weight: 700;
  color: ${props => props.theme.custom.palette.secondary900};
`;

const EmptyStateDescription = styled(Typography)`
  font-size: 1.6rem;
  color: ${props => props.theme.custom.palette.secondary700};
  line-height: 1.5;
  margin-bottom: 1rem;
`;

const EmptyStateButton = styled(Button)`
  font-size: 1.6rem;
  font-weight: 600;
  padding: 1.2rem 2.4rem;
  text-transform: none;
`;

type Props = {
  onAddContractor: () => void;
};

export const ContractorsEmptyState: React.FC<Props> = ({ onAddContractor }) => {
  const { t } = useTranslation();

  return (
    <EmptyStateWrapper>
      <EmptyStateIconWrapper icon="nav-customer" width="12rem" height="12rem" />
      <EmptyStateTitle>
        {t('customers.table.emptyStateTitleCustomers')}
      </EmptyStateTitle>
      <EmptyStateDescription>
        {t('customers.table.emptyStateDescriptionCustomers')}
      </EmptyStateDescription>
      <EmptyStateButton
        variant="contained"
        color="primary"
        onClick={onAddContractor}
      >
        {t('customers.table.emptyStateButtonCustomers')}
      </EmptyStateButton>
    </EmptyStateWrapper>
  );
};
